import { useNotifications } from '../queries/useNotifications.js'
import { useUIStore } from '../store/uiStore.js'

/**
 * NotificationBell — 🔔 button in the top nav with an unread-count
 * badge. Click toggles the NotificationPanel.
 */
export default function NotificationBell() {
  const { unreadCount } = useNotifications()
  const open = useUIStore((s) => s.notifOpen)
  const toggle = useUIStore((s) => s.toggleNotifs)

  return (
    <button
      type="button"
      onClick={toggle}
      title={
        unreadCount > 0
          ? `${unreadCount} unread notification${unreadCount === 1 ? '' : 's'}`
          : 'Notifications'
      }
      style={{
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 32,
        height: 28,
        padding: 0,
        border: '1px solid var(--border)',
        borderRadius: 99,
        background: open ? '#eff6ff' : '#fff',
        color: 'var(--muted)',
        cursor: 'pointer',
        fontSize: 14,
      }}
    >
      🔔
      {unreadCount > 0 && (
        <span
          style={{
            position: 'absolute',
            top: -5,
            right: -5,
            background: '#ef4444',
            color: '#fff',
            fontSize: 9,
            fontWeight: 800,
            padding: '1px 5px',
            borderRadius: 99,
            minWidth: 14,
            textAlign: 'center',
            border: '1.5px solid #fff',
            lineHeight: 1.2,
          }}
        >
          {unreadCount > 9 ? '9+' : unreadCount}
        </span>
      )}
    </button>
  )
}
